import { Controller } from "@hotwired/stimulus"
import { createConsumer } from "@rails/actioncable"

// Stimulus controller for real-time todo progress updates on ERB task panels
// Subscribes to ActionCable BuildProgressChannel and updates DOM on task_todo_update events
export default class extends Controller {
  static values = {
    sessionId: String,
    taskId: String
  }

  static targets = ["todoList", "progressBar", "progressText", "activity"]

  connect() {
    if (!this.sessionIdValue || !this.taskIdValue) return

    this.consumer = createConsumer()
    this.subscription = this.consumer.subscriptions.create(
      { channel: "BuildProgressChannel", build_session_id: this.sessionIdValue },
      {
        received: (data) => this.handleMessage(data)
      }
    )
  }

  disconnect() {
    if (this.subscription) {
      this.subscription.unsubscribe()
    }
    if (this.consumer) {
      this.consumer.disconnect()
    }
  }

  handleMessage(data) {
    if (data.type !== "task_todo_update") return
    if (data.task_id !== this.taskIdValue) return

    this.updateTodos(data)
  }

  updateTodos(data) {
    const { todos, progress, current_activity } = data
    if (!todos) return

    const percentage = Math.round(progress * 100)

    // Update progress bar
    if (this.hasProgressBarTarget) {
      this.progressBarTarget.value = percentage
    }

    // Update progress text
    if (this.hasProgressTextTarget) {
      this.progressTextTarget.textContent = `${percentage}%`
    }

    // Update current activity
    if (this.hasActivityTarget) {
      this.activityTarget.textContent = current_activity || ""
      this.activityTarget.style.display = current_activity ? "block" : "none"
    }

    // Update todo list
    if (this.hasTodoListTarget) {
      this.todoListTarget.innerHTML = todos.map(todo => {
        const icon = todo.status === "completed"
          ? '<i class="fas fa-check-circle text-success text-xs"></i>'
          : todo.status === "in_progress"
          ? '<i class="fas fa-spinner fa-spin text-info text-xs"></i>'
          : '<i class="far fa-circle text-base-content/30 text-xs"></i>'

        const textClass = todo.status === "completed" ? "text-base-content/50 line-through" : ""
        const content = todo.status === "in_progress" ? (todo.activeForm || todo.content) : todo.content

        return `<li class="flex items-center gap-2 text-sm py-0.5">${icon}<span class="${textClass}">${this.escapeHtml(content)}</span></li>`
      }).join("")
    }

    // Show the container if it was hidden
    this.element.style.display = "block"
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
